"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const filterIterable_1 = require("../utils/filterIterable");
const mapIterable_1 = require("../utils/mapIterable");
function jsonSocket(createSocket) {
    const socket = createSocket();
    return Object.assign(Object.assign({}, socket), { send(message) {
            socket.open().then(() => socket.send(JSON.stringify(message)));
        },
        sendBinary(message) {
            socket.open().then(() => socket.send(message));
        },
        watch() {
            const watcher = socket.watch();
            const iterator = mapIterable_1.mapIterable(filterIterable_1.filterIterable(watcher, (message) => typeof message === 'string'), message => JSON.parse(message));
            return Object.assign(Object.assign({}, iterator), { return(...args) {
                    watcher.return();
                    return iterator.return(...args);
                } });
        },
        watchBinary() {
            const watcher = socket.watch();
            const iterator = filterIterable_1.filterIterable(watcher, (message) => {
                return message instanceof ArrayBuffer;
            });
            return Object.assign(Object.assign({}, iterator), { return(...args) {
                    watcher.return();
                    return iterator.return(...args);
                } });
        } });
}
exports.default = jsonSocket;
//# sourceMappingURL=jsonSocket.js.map